import { OrderState } from '@prisma/client';
import { createZodDto } from 'nestjs-zod';
import { z } from 'zod';

export const userMeasurementPreviewDto = z.object({
  id: z.string(),
  timestamp: z.date(),
  order: z.object({ state: z.nativeEnum(OrderState) }),
  outdated: z.boolean(),
});

export const userMeasurementPreviewListDto = z.object({
  measurements: userMeasurementPreviewDto.array(),
  containsOutdated: z.boolean(),
  latestFormulaCreatedAt: z.date().optional(),
});

export class UserMeasurementPreviewDto extends createZodDto(
  userMeasurementPreviewDto,
) {}

export class UserMeasurementPreviewListDto extends createZodDto(
  userMeasurementPreviewListDto,
) {}
